module.exports = __webpack_public_path__ + "static/egil-90acb1aed888fed10993f29be3d72207.png";